<!--- Componente Paletizado con Lectura de cajas ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el componente:
-----------------------
-

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div class="main-PCRegistroActividadPorEnvase">
    <!-- Escanear Codigo trabajador -->
    <UCCodeScanner
      v-if="mostrarBotonLecturaCajas"
      :text-button="$t('common.scan')"
      :allow-manual-code-entry="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      :auto-open-camera="configuracionLecturaCajas.LecturaContinuaCodigosBarras || !configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      :autofocus-on-input="configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual"
      :cabecera-popup="$t('production.common.activitiesRecord')"
      :sub-title="$t('production.common.boxIdentifier')"
      :sub-title-value="articuloElaborado != null ? articuloElaborado.CodigoBarras.toString() : ''"
      @code-reading="EventoLecturaDeCodigoDeBarrasRegistroActividad"
      @codigo-barras="EventoLecturaDeCodigoDeBarrasRegistroActividad"
    />
    <!-- Listado Cajas asociadas al Palé -->
    <div
      v-if="articuloElaborado != null"
      class="div-cabeceraTituloCajasAsociadas"
    >
      <div class="div-cabeceraTituloCajasAsociadas__pre-nombres">
        <span>
          {{ `${$t('production.common.boxIdentifier')}:` }}
        </span>
        <span>
          {{ `${$t('common.product')}:` }}
        </span>
        <span>
          {{ `${$t('common.package')}:` }}
        </span>
      </div>
      <div
        v-if="articuloElaborado != null"
        class="div-cabeceraTituloCajasAsociadas__nombres"
      >
        <span>  {{ articuloElaborado.CodigoBarras }}   </span>
        <span v-if="articuloElaborado.Producto != null"> {{ articuloElaborado.Producto.Descripcion }} </span>
        <span v-if="articuloElaborado.Envase != null">  {{ articuloElaborado.Envase.DescripcionCorta }}  </span>
      </div>
    </div>
    <div class="div-listado">
      <UCPreload :show="preloader" />
      <div
        v-for="registroActividad in lstRegistrosActividad"
        :key="registroActividad.Id"
        class="div-registro"
      >
        <f7-row>
          <f7-col width="70">
            <f7-row>
              <f7-col width="100">
                <div class="display-flex">
                  <span
                    :class="registroActividad.Id !== 0 || (articuloElaborado.sinSincronizar !== undefined && articuloElaborado.sinSincronizar) ? 'span-texto-azulOscuro-22-500' : 'span-texto-rojoError-22-500'"
                  >{{ registroActividad.IdUnicoCodigoBarras }}</span>
                </div>
              </f7-col>
            </f7-row>
            <f7-row>
              <f7-col width="100">
                <span
                  v-if="registroActividad.Id === 0 "
                  class="div-registro__sub-title"
                >{{ registroActividad.mensajeError }}</span>
                <span
                  v-if="registroActividad.Trabajador != null && registroActividad.Trabajador.Sujeto != null"
                  class="div-registro__sub-title"
                >{{ `${registroActividad.Trabajador.Sujeto.Nombre} ${registroActividad.Trabajador.Sujeto.PrimerApellido}` }}</span>
              </f7-col>
            </f7-row>
            <f7-row>
              <f7-col width="100">
                <span
                  v-if="registroActividad.ActividadProduccion != null"
                  class="div-registro__sub-title-2"
                >{{ registroActividad.ActividadProduccion.DescripcionCorta }}</span>
              </f7-col>
            </f7-row>
          </f7-col>
          <f7-col
            width="15"
            class=""
          />
          <f7-col
            width="15"
            class=""
          >
            <div class="display-flex">
              <div
                v-if="registroActividad.Id !== 0"
                class="btn-base-rojo-1 seleccionable"
                @click="SolicitarEliminarRegistroTrabajador(registroActividad)"
              >
                <img
                  src="@/static/icons/ic_trash_white.svg"
                  alt="iconDelete"
                  width="14px"
                >
              </div>
              <div
                v-else
                class="btn-base-rojo-1 seleccionable"
                @click="SolicitarEliminarRegistroTrabajadorLocal(registroActividad)"
              >
                <img
                  src="@/static/icons/ic_trash_white.svg"
                  alt="iconDelete"
                  width="14px"
                >
              </div>
            </div>
          </f7-col>
        </f7-row>
      </div> <!-- Fin registro -->
    </div>

    <!-- Action Confirmación Eliminar Palé -->
    <UCConfirmation ref="componenteConfirmacionEliminarPale" />
  </div>
</template>

<script>
import { Log } from '@/js/common/HIDebuggingSupport';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { callExecuteSPERP } from '@/js/services/APIErp';
import { notifyReadingError } from '@/js/utils/notifyReadingError';

export default {
  name: 'PCRegistroActividadPorEnvase',
  components: {
    UCCodeScanner,
    UCPreload,
    UCConfirmation,
  },
  props: {
    articuloElaborado: {
      type: Object,
      default: null,
    },
    configuracionLecturaCajas: {
      type: Object,
      required: true,
    },
    configuracionLecturaRegistroAct: {
      type: Object,
      required: true,
    },
  },

  emits: [
    'lista-registros',
    'elemento-local-eliminado',
  ],

  data() {
    return {
      lstRegistrosActividad: [],
      preloader: false,
    };
  },
  computed: {
    mostrarBotonLecturaCajas() {
      return this.articuloElaborado != null;
    },
  },
  watch: {
    articuloElaborado: {
      handler(val) {
        if (val != null) {
          this.ArticuloElaboradoEstablecido(val);
        } else {
          this.RestablecerFrm();
        }
      },
      deep: true,
    },
  },

  methods: {
    RestablecerFrm() {
      this.lstRegistrosActividad = [];
    },

    async EventoLecturaDeCodigoDeBarrasRegistroActividad(codigoBarras) {
      Log(this, this.EventoLecturaDeCodigoDeBarrasRegistroActividad.name);
      const prefijoCaja = codigoBarras.substring(0, 2);
      if (prefijoCaja !== '80') {
        notifyReadingError(this.$t('production.info.errorExpectedRegistrationLabel'));
        this.preloader = false;
        return;
      }

      this.preloader = true;
      this.codigoDeBarrasParaBusqueda = codigoBarras;
      const codigoActividadPro = codigoBarras.substring(2, 5);
      const codigoTarjeta = codigoBarras.substring(5, 12);
      const codTarjetaSinCeros = codigoTarjeta.replace(/^0+/, '');

      this.codigoDeBarrasParaBusqueda = codigoBarras;

      const registroActividad = {
        IdUnicoCodigoBarras: codigoBarras,
        ArticuloElaborado: {
          Id: this.articuloElaborado.Id,
        },
        ActividadProduccion: {
          Codigo: codigoActividadPro,
        },
        Trabajador: {
          Codigo: codTarjetaSinCeros,
        },

      };
      let exists = false;
      this.lstRegistrosActividad.forEach((registro) => {
        if (registro.IdUnicoCodigoBarras === codigoBarras) {
          exists = true;
        }
      });
      if (exists) {
        notifyReadingError(this.$t('production.assignBoxesPallet.workerLogExist'));
        this.preloader = false;
        return;
      }
      if ((this.configuracionLecturaCajas.LecturaContinuaCodigosBarras || this.configuracionLecturaCajas.LecturaContinuaCodigosBarrasManual) && this.configuracionLecturaRegistroAct.LecturaContinuaCodigosBarras) {
        if (this.articuloElaborado.Id !== 0) {
          const result = await this.Conexion_AsociarActividaRegistroArticuloElaborado([registroActividad]);
          /* this.lstRegistrosActividad = await this.Conexion_ObtenerRegistroActividades(this.articuloElaborado.Id); */
          if (result.OK.length > 0) {
            this.lstRegistrosActividad.push(result.OK[0].tag);
            this.$emit('lista-registros', result.OK[0].tag);
          }
        } else {
          registroActividad.Id = 0;
          registroActividad.ArticuloElaborado.CodigoBarras = this.articuloElaborado.CodigoBarras;
          this.lstRegistrosActividad.push(registroActividad);
          this.$emit('lista-registros', registroActividad);
        }
      } else {
        this.lstRegistrosActividad = [];
        const result = await this.Conexion_AsociarActividaRegistroArticuloElaborado([registroActividad]);
        this.lstRegistrosActividad = await this.Conexion_ObtenerRegistroActividades(this.articuloElaborado.Id);
        if (result.OK.length > 0) {
          this.$emit('lista-registros', result.OK[0].tag);
        }
      }

      this.preloader = false;
    },
    /** * Método ArticuloElaboradoEstablecido */
    async ArticuloElaboradoEstablecido() {
      Log(this, this.ArticuloElaboradoEstablecido.name);
      this.preloader = true;
      this.lstRegistrosActividad = [];
      this.lstRegistrosActividad = await this.Conexion_ObtenerRegistroActividades(this.articuloElaborado.Id);
      this.articuloElaborado.ArticuloRegistro.forEach((element) => {
        if (element.Id === 0) {
          this.lstRegistrosActividad.push(element);
        }
      });
      this.preloader = false;
    },
    /** * Método SolicitarEliminarArticuloElaborado */
    SolicitarEliminarRegistroTrabajador(objRegistroActividad) {
      Log(this, this.SolicitarEliminarRegistroTrabajador.name);
      this.$refs.componenteConfirmacionEliminarPale.create(
        this.$t('production.packagingActivityRecords.deleteActivityRecord.title'),
        this.$t('production.packagingActivityRecords.deleteActivityRecord.text'),
        () => {
          this.EliminarArticuloElaborado(objRegistroActividad);
        },
      );
      this.$refs.componenteConfirmacionEliminarPale.show();
    },
    SolicitarEliminarRegistroTrabajadorLocal(objRegistroActividad) {
      Log(this, this.SolicitarEliminarRegistroTrabajadorLocal.name);
      this.$refs.componenteConfirmacionEliminarPale.create(
        this.$t('production.packagingActivityRecords.deleteActivityRecord.title'),
        this.$t('production.packagingActivityRecords.deleteActivityRecord.text'),
        () => {
          this.EliminarRegistroLocal(objRegistroActividad);
        },
      );
      this.$refs.componenteConfirmacionEliminarPale.show();
    },
    EliminarRegistroLocal(objRegistroActividad) {
      Log(this, this.EliminarRegistroLocal.name);
      this.lstRegistrosActividad = this.lstRegistrosActividad.filter((registro) => registro.IdUnicoCodigoBarras !== objRegistroActividad.IdUnicoCodigoBarras);
      this.$emit('elemento-local-eliminado', objRegistroActividad);
    },
    /** * Método EliminarArticuloElaborado */
    async EliminarArticuloElaborado(objRegistroActividad) {
      Log(this, this.EliminarArticuloElaborado.name);
      this.preloader = true;
      this.lstRegistrosActividad = [];
      await this.Conexion_EliminarRegistroActividadArticuloElaborado(objRegistroActividad.Id);
      this.lstRegistrosActividad = await this.Conexion_ObtenerRegistroActividades(this.articuloElaborado.Id);
      this.preloader = false;
    },
    async Conexion_AsociarActividaRegistroArticuloElaborado(lstRegistrosActividad) {
      Log(this, this.Conexion_AsociarActividaRegistroArticuloElaborado.name);
      try {
        const result = await ConexionTA.callGuardarArticuloElaboradoRegistroActividad(lstRegistrosActividad);
        if (result.Valor) {
          result.Tag.ERROR.forEach((element) => {
            HiNotification.Toast(`${element.mensaje} : ${element.tag.IdUnicoCodigoBarras}`);
          });

          if (result.Tag.ERROR.length > 0) {
            notifyReadingError();
          }

          return result.Tag;
        }

        notifyReadingError();
        return false;
      } catch {
        // return false;
        notifyReadingError(this.$t('common.checkYourConnection'));
        return false;
      }
    },

    /** * Método Conexion_EliminarRegistroActividadArticuloElaborado */
    async Conexion_EliminarRegistroActividadArticuloElaborado(idRegistroActividad) {
      Log(this, this.Conexion_EliminarRegistroActividadArticuloElaborado.name);
      try {
        const result = await ConexionTA.callEliminarRegistroActividadArticuloElaborado(idRegistroActividad);
        if (result.Valor) {
          return true;
        }
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        return false;
      } catch {
        return false;
        // HiNotification.Toast(this.$t('common.checkYourConnection'));
      }
    },
    async Conexion_ObtenerRegistroActividades(idArt) {
      Log(this, this.Conexion_ObtenerRegistroActividades.name);
      try {
        const result = await callExecuteSPERP(
          'APPERPAGRO_RegistrosActividadXArticuloElaborado',
          [
            { NombreParametro: 'idArtElaborado', Valor: idArt },
          ],
          'Trazabilidad.ArticuloElaboradoRegistroActividadJSON',
        );
        if (result.statusText === 'OK') {
          return result.data;
        }
        return [];
      } catch {
        return [];
      }
    },

  },
};
</script>

<style scoped lang="scss">
.main-PCRegistroActividadPorEnvase {
  .btn-base-gris-1 {
    width: 48px;
    height: 48px;
    min-height: 48px;
    min-width: 48px;
  }

  /* Permite que el boton flotante de Confirmar  este flotante sin desplazamiento */
  .md .fab[class*="-bottom"] {
    position: fixed;
  }

  .div-cabeceraTituloCajasAsociadas {
    display: flex;
    color: #24253d;
    text-transform: none;
    font-size: 17px;
    background: var(--his-oliva-tint);
    padding-left: 25px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 4px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-color: var(--his-disabled);
    border-style: solid;

    &__pre-nombres {
      display: flex;
      flex-direction: column;
    }

    &__nombres {
      display: flex;
      flex-direction: column;
      margin-left: 40px;
      color: var(--his-steel-blue);
    }
  }

  .div-registro {
    padding: 10px;
    padding-left: 25px;
    border-bottom: 1px;
    border-top: 0;
    border-right: 0;
    border-left: 0;
    border-color: var(--his-disabled);
    border-style: solid;

    &__sub-title {
      color: var(--his-steel-blue);
      font-size: 14px;
      font-weight: 500;
    }

    &__sub-title-2 {
      color: var(--his-oliva);
      font-size: 14px;
      font-weight: 500;
    }
  }

  .div-listado {
    max-height: 100%;
    height: 50vh;
    overflow-y: auto;
  }
}
</style>
